import $ from "jquery";

const GenericContainer = {
    variable: {
        genericContainers: $(".generic-container"),
        desktopQuery: "(min-width: 992px)",
        tabletQuery: "(min-width: 768px) and (max-width: 991px)",
        mobileQuery: "(max-width: 767px)",
    },

    methods: {
        applyStyles: function ($container) {
            const properties = {
                backgroundColor: $container.data("background-color"),
                textColor: $container.data("text-color"),
                isGradient: $container.data("is-gradient"),
                desktop: {
                    backgroundImage: $container.data("desktop-background-image"),
                    marginTop: $container.data("desktop-margin-top"),
                    marginBottom: $container.data("desktop-margin-bottom"),
                    marginLeft: $container.data("desktop-margin-left"),
                    marginRight: $container.data("desktop-margin-right"),
                    paddingTop: $container.data("desktop-padding-top"),
                    paddingBottom: $container.data("desktop-padding-bottom"),
                    paddingLeft: $container.data("desktop-padding-left"),
                    paddingRight: $container.data("desktop-padding-right"),
                },
                mobile: {
                    backgroundImage: $container.data("mobile-background-image"),
                    marginTop: $container.data("mobile-margin-top"),
                    marginBottom: $container.data("mobile-margin-bottom"),
                    marginLeft: $container.data("mobile-margin-left"),
                    marginRight: $container.data("mobile-margin-right"),
                    paddingTop: $container.data("mobile-padding-top"),
                    paddingBottom: $container.data("mobile-padding-bottom"),
                    paddingLeft: $container.data("mobile-padding-left"),
                    paddingRight: $container.data("mobile-padding-right"),
                },
                tablet: {
                    backgroundImage: $container.data("tablet-background-image"),
                    marginTop: $container.data("tablet-margin-top"),
                    marginBottom: $container.data("tablet-margin-bottom"),
                    marginLeft: $container.data("tablet-margin-left"),
                    marginRight: $container.data("tablet-margin-right"),
                    paddingTop: $container.data("tablet-padding-top"),
                    paddingBottom: $container.data("tablet-padding-bottom"),
                    paddingLeft: $container.data("tablet-padding-left"),
                    paddingRight: $container.data("tablet-padding-right"),
                },
            };

            $container.css(
                "background",
                properties.isGradient
                    ? `linear-gradient( ${properties.backgroundColor} , #FFFFFF)`
                    : properties.backgroundColor
            );
            $container.css("color", properties.textColor);
            const applyDeviceStyles = (deviceProps) => {
                $container.css({
                    "margin-top": deviceProps.marginTop + "px",
                    "margin-bottom": deviceProps.marginBottom + "px",
                    "margin-left": deviceProps.marginLeft + "px",
                    "margin-right": deviceProps.marginRight + "px",
                    "padding-top": deviceProps.paddingTop + "px",
                    "padding-bottom": deviceProps.paddingBottom + "px",
                    "padding-left": deviceProps.paddingLeft + "px",
                    "padding-right": deviceProps.paddingRight + "px",
                });
            };

            if (window.matchMedia(GenericContainer.variable.desktopQuery).matches) {
                applyDeviceStyles(properties.desktop);
            } else if (window.matchMedia(GenericContainer.variable.tabletQuery).matches) {
                applyDeviceStyles(properties.tablet);
            } else if (window.matchMedia(GenericContainer.variable.mobileQuery).matches) {
                applyDeviceStyles(properties.mobile);
            }
        },
    },
};
if (GenericContainer.variable.genericContainers.length > 0) {
    GenericContainer.variable.genericContainers.each(function () {
        GenericContainer.methods.applyStyles($(this));
    });
}
